import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Page = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.bgColor};
`;

const Header = styled.header`
  background: #fff;
  border-bottom: 1px solid #E8ECF0;
  padding: 16px 0;
`;

const HeaderInner = styled.div`
  max-width: 1080px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;

const Brand = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Logo = styled.img`
  height: 40px;
  width: auto;
  object-fit: contain;
`;

const Name = styled.div`
  font-size: ${({ theme }) => theme.metrics.font.size.lg};
  font-weight: ${({ theme }) => theme.metrics.font.weight.bold};
  color: ${({ theme }) => theme.colors.text.primary};
`;

const LangPicker = styled.select`
  border: 1px solid #E0E4E8;
  border-radius: 6px;
  padding: 6px 8px;
  background: #fff;
  font-family: ${({ theme }) => theme.metrics.font.family};
  font-size: ${({ theme }) => theme.metrics.font.size.sm};
  color: ${({ theme }) => theme.colors.text.primary};
  cursor: pointer;
`;

const Main = styled.main`
  flex: 1;
  max-width: 1080px;
  width: 100%;
  margin: 0 auto;
  padding: 32px 24px 64px;
`;

const Footer = styled.footer`
  background: #fff;
  border-top: 1px solid #E8ECF0;
  padding: 16px 24px;
  text-align: center;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.dark.little};
`;

const LANGS = [
  { code: 'tr', label: 'Türkçe' },
  { code: 'en', label: 'English' },
  { code: 'ru', label: 'Русский' },
  { code: 'kk', label: 'Қазақша' },
  { code: 'az', label: 'Azərbaycanca' },
];

export default function CareerLayout({ tenant, children }) {
  const { t, i18n } = useTranslation();

  return (
    <Page>
      <Header>
        <HeaderInner>
          <Brand>
            {tenant?.logoUrl && <Logo src={tenant.logoUrl} alt={tenant.name} />}
            <Name>{tenant?.name || ''}</Name>
          </Brand>
          <LangPicker
            value={i18n.language || 'tr'}
            onChange={(e) => i18n.changeLanguage(e.target.value)}
          >
            {LANGS.map((l) => <option key={l.code} value={l.code}>{l.label}</option>)}
          </LangPicker>
        </HeaderInner>
      </Header>
      <Main>{children}</Main>
      <Footer>{t('career.poweredBy')}</Footer>
    </Page>
  );
}
